import COLORS from '../../utils/constants/colors'

const invitationLandingStyles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
  },
  org: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  orgLogo: {
    width: 48,
    height: 48,
  },
  orgName: {
    fontWeight: 600,
    fontSize: 18,
  },
  link: {
    color: COLORS.purple,
    alignSelf: 'flex-start',
  },
}

export default invitationLandingStyles
